import type { SubjectTypeDefinitionPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';

export type SubjectTypeDefinitionFetchedAction = {
	type: 'SUBJECT_TYPE_DEFINITION_FETCHED';
	payload: SubjectTypeDefinitionPayload;
	accountId: number;
};

export default (
	payload: SubjectTypeDefinitionPayload,
	accountId: number,
): SubjectTypeDefinitionFetchedAction => ({
	type: 'SUBJECT_TYPE_DEFINITION_FETCHED',
	payload,
	accountId,
});
